<script>
export default {
  name: "secoords-add",
  props: {
    secoords: {
      visible: Boolean,
      operate: String,
      formData: {},
    },
    secoordsList: Array
  },
  data() {
    const repetition = (rule, value, callback) => {
      let reg =  /^[1-9]\d*$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        for (let i = 0; i < this.secoordsList.length; i++) {
          if (i !== this.secoords.index) {
            if (this.secoordsList[i].no == value) {
              callback(new Error("序号不能重复"));
            }
          }
        }
        callback();
      }
    };
    return {
      typeList: [],
      rules: {
        no: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { required: true, trigger: "blur", validator: repetition }
        ],
        x: [
          { required: true, message: '请输入X坐标', trigger: 'blur' },
        ],
        y: [
          { required: true, message: '请输入Y坐标', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    handleClose() {
      this.secoords.index = undefined;
      this.secoords.formData = {};
      this.$refs["df"].clearValidate();
    },
    save() {
      this.$refs['df'].validate((valid) => {
        if (valid) {
          if (this.secoords.index !== undefined) {
            this.secoordsList.splice(this.secoords.index, 1, this.secoords.formData)
          } else {
            this.secoordsList.push(this.secoords.formData);
          }
          this.secoords.visible = false;
        } else {
          return false
        }
      });
    },
    numberInput(val) {
      let INTEGER_LENGTH = 5;
      let DECIMAL_LENGTH = 3;
      let str = val.replace('-', '');
      let intStr, decStr;

      // 判断是否是浮点数
      if (str.indexOf('.') === -1) {
        intStr = str;
      } else {
        let arr = str.split('.');
        intStr = arr[0];
        decStr = arr[1];
      }

      // 处理整数位
      if (intStr.length > INTEGER_LENGTH) {
        intStr = intStr.substr(0, INTEGER_LENGTH);
      }

      // 处理小数位
      if (decStr && decStr.length > DECIMAL_LENGTH) {
        decStr = decStr.substr(0, DECIMAL_LENGTH);
      }

      // 组合
      if (val.indexOf('-') === -1) {
        return decStr ? intStr + '.' + decStr : intStr;
      } else {
        return decStr ? '-' + intStr + '.' + decStr : '-' + intStr;
      }
    }
  },
}
</script>

<template>
  <el-dialog
      :visible.sync="secoords.visible"
      :close-on-click-modal="false"
      width="25%"
      @close="handleClose"
      append-to-body>
    <div slot="title" class="header-title">
      <div class="dgTitle">{{ secoords.title }}</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="secoords.visible = false"></el-image>
    </div>
    <el-form ref="df" :model="secoords.formData" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item label="序号" prop="no">
            <el-input v-model="secoords.formData.no" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="轮廓类型">
            <el-input v-model="secoords.formData.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="X坐标" prop="x">
            <el-input
                v-model="secoords.formData.x"
                type="number"
                @input="secoords.formData.x = numberInput(secoords.formData.x)">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Y坐标" prop="y">
            <el-input
                v-model="secoords.formData.y"
                type="number"
                @input="secoords.formData.y = numberInput(secoords.formData.y)">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="secoords.visible = false" class="dgClose">关 闭</el-button>
        <template>
          <el-button
              slot="reference"
              type="primary"
              @click="save"
              class="dgSave">保 存
          </el-button>
        </template>
    </span>
  </el-dialog>
</template>

<style scoped>
.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>